import * as a from "react";
import m from "../lib/IconBase.es.js";
import c from "../defs/ExclamationMark.es.js";
const o = a.forwardRef((r, t) => /* @__PURE__ */ a.createElement(m, { ref: t, ...r, weights: c }));
o.displayName = "ExclamationMarkIcon";
const i = o;
export {
  i as ExclamationMark,
  o as ExclamationMarkIcon
};
